import axios from 'axios'
import { tsWhoAmI } from '../../Typescript/API_Response'

const pyClient = (whoAmI: tsWhoAmI) =>
  (() => {
    return axios.create({
      baseURL: `${['development', 'production', undefined].includes(process.env.REACT_APP_STAGE) ? window.location.origin : 'http://localhost:8000'}/api/v2/`, //use proxy for development
      // baseURL: `${['development', 'production', undefined].includes(process.env.REACT_APP_STAGE) ? window.location.origin : '`, //empty redirects to testabr proxy
      params: {
        EmployeeID: whoAmI.user,
        Token: whoAmI.token,
      },
      headers: {
        'content-type': 'application/json',
      },
    })
  })()

export default pyClient
